import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from '@airasia-common/libraries/constants';
import { SubBodyText, BodyText } from '../Text/Heading';
import Row from '../Container/Row';
import PopoverTag from '../PopoverTag';
import Wrapper from '../Wrapper/Wrapper';
import useWindowSize from '../../utils/windowSize';
import Amenity from './Amenity';

const ShowMoreLabel = styled(SubBodyText)`
  cursor: pointer;
  margin-top: 6px;
  font-weight: 500;
`;

const AllAmenitiesWrapper = styled(Wrapper)`
  max-height: 280px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
`;

export const TYPE = {
  ONE_ROW: 'one_row',
  ONE_COLUMN: 'one_column',
  ONE_COLUMN_FULL_WIDTH: 'one_column_full_width',
  TWO_COLUMN: 'two_column',
  ONE_ROW_DEVICE_ITEM: 'one_row_devive_item',
};

export const AmenitiesList = ({
  amenities,
  type,
  size = 24,
  translateFunc,
  isShowGalleryRoomDetail,
  isShowPopover,
  allHotelAmenitiesLabel,
  moreLabel,
  theme,
  move,
}) => {
  const { isMobileView } = useWindowSize();
  let configuration = {};
  switch (type) {
    case TYPE.ONE_COLUMN:
      configuration = { isVertical: false, percentWidth: 50 };
      break;
    case TYPE.ONE_COLUMN_FULL_WIDTH:
      configuration = { isVertical: false, percentWidth: 100 };
      break;
    case TYPE.TWO_COLUMN:
      configuration = { isVertical: false, percentWidth: 50 };
      break;
    case TYPE.ONE_ROW_DEVICE_ITEM:
      configuration = { isVertical: false, showDeviveItemSymbol: true };
      break;
    default:
      configuration = { isVertical: true, percentWidth: 100 };
      break;
  }

  const allItems = amenities.map((amenity, index) => {
    let conf = {
      isVertical: false,
      percentWidth: 25,
      isShowPopover: isShowPopover,
      isPopoverItem: true,
    };
    if (index === amenities.length - 1) conf.showDeviveItemSymbol = false;
    return (
      <Amenity
        key={index}
        {...amenity}
        {...conf}
        size={size}
        translateFunc={translateFunc}
      />
    );
  });

  const listItems = amenities.map((amenity, index) => {
    let conf = { ...configuration };
    if (index === amenities.length - 1) conf.showDeviveItemSymbol = false;
    if (!isMobileView && isShowPopover && amenities.length >= 6) {
      if (index < 6) {
        if (index < 5) {
          return (
            <Amenity
              key={index}
              {...amenity}
              {...conf}
              size={size}
              translateFunc={translateFunc}
              isShowGalleryRoomDetail={isShowGalleryRoomDetail}
              isShowPopover={isShowPopover}
              allItems={allItems}
              allHotelAmenitiesLabel={allHotelAmenitiesLabel}
            />
          );
        } else {
          return (
            <PopoverTag
              theme={theme}
              content={
                <AllAmenitiesWrapper>
                  <BodyText
                    style={{
                      width: '100%',
                      marginBottom: '16px',
                    }}
                  >
                    {allHotelAmenitiesLabel}
                  </BodyText>
                  {allItems}
                </AllAmenitiesWrapper>
              }
              position="top"
              background={Colors.primaryWhite}
              borderRadius={4}
              left={'auto'}
              top={'inherit'}
              bottom={'110%'}
              fontSizeContent={'14px'}
              paddingContent={'16px 12px'}
              colorContent={Colors.greyDarker}
              width={775}
              right={'0'}
              rightArrow={'16px'}
              label={
                <ShowMoreLabel color="tertiaryRed">{moreLabel}</ShowMoreLabel>
              }
            />
          );
        }
      }
    } else {
      return (
        <Amenity
          key={index}
          {...amenity}
          {...conf}
          size={size}
          translateFunc={translateFunc}
          isShowGalleryRoomDetail={isShowGalleryRoomDetail}
          isShowPopover={isShowPopover}
        />
      );
    }
  });
  return (
    <Row
      flexDirection={
        type === TYPE.ONE_COLUMN || type === TYPE.ONE_COLUMN_FULL_WIDTH
          ? 'column'
          : 'row'
      }
      justifyContent="flex-start"
      flexWrap={isShowPopover && isMobileView ? 'nowrap' : 'wrap'}
      style={{
        overflowX: isShowPopover && isMobileView && 'scroll',
      }}
    >
      {listItems}
    </Row>
  );
};

AmenitiesList.propTypes = {
  amenities: PropTypes.array,
  type: PropTypes.string,
  size: PropTypes.number,
  translateFunc: PropTypes.func,
  isShowGalleryRoomDetail: PropTypes.bool,
  isShowPopover: PropTypes.bool,
  allHotelAmenitiesLabel: PropTypes.string,
  moreLabel: PropTypes.string,
  theme: PropTypes.string,
  move: PropTypes.bool,
};
